<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Admin' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>漂流瓶列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
      <el-row class="form-row">
        <el-text style="width:100px; text-align: right;">类型：</el-text>
        <el-col :span="21">
          <el-radio-group v-model="typeValueId">
            <template v-for="tItem in typeList">
              <el-radio :label="tItem.id" v-if="tItem.name != '信箱'">{{ tItem.name }}</el-radio>
            </template>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row class="form-row">
        <el-text style="width:100px; text-align: right;">名称：</el-text>
        <el-col :span="4">
          <el-input placeholder="请输入名称" style="width:400px;" max-l v-model="subData.title"></el-input>
        </el-col>
      </el-row>
      <el-row class="form-row">
        <el-text style="width:100px; text-align: right;">描述：</el-text>
        <el-col :span="4">
          <el-input placeholder="请输入描述" style="width:400px;" max-l v-model="subData.remark"></el-input>
        </el-col>
      </el-row>
      <el-row class="form-row" v-if="typeShowName=='邮票' || typeShowName=='物品'">
        <el-text style="width:100px; text-align: right;">图片路径：</el-text>
        <el-col :span="4">
          <el-upload
            class="avatar-uploader"
            :action="uploadUrl"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="subData.imgPath" :src="subData.imgPath" style="height:150px;" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon" style="font-size:60px; font-style:normal;">+</i>
          </el-upload>
        </el-col>
      </el-row>
      <el-row class="form-row" v-if="false">
        <el-text style="width:100px; text-align: right;">声音路径：</el-text>
        <el-col :span="4">
          <el-input placeholder="请输入声音路径" style="width:400px;" max-l v-model="subData.voicePath"></el-input>
        </el-col>
      </el-row>
      <el-row class="form-row" v-if="typeShowName=='邮票'||typeShowName=='会员卡'">
        <el-text style="width:100px; text-align: right;">数量：</el-text>
        <el-col :span="4">
          <el-input placeholder="请输入数量" style="width:400px;" max-l v-model="subData.num"></el-input>
        </el-col>
      </el-row>
      <el-row class="form-row">
        <el-text style="width:100px; text-align: right;">几率：</el-text>
        <el-col :span="4">
          <el-input placeholder="请输入几率" style="width:400px;" max-l v-model="subData.rate"></el-input>
        </el-col>
      </el-row>
      <el-row class="form-row">
        <el-text style="width:100px; text-align: right;">总数：</el-text>
        <el-col :span="4">
          <el-input placeholder="请输入总数，该漂流瓶总共数量，0是无限" style="width:400px;" max-l v-model="subData.maxCount"></el-input>
        </el-col>
      </el-row>
      <el-row class="form-row">
        <el-text style="width:100px; text-align: right;">剩余数量：</el-text>
        <el-col :span="4">
          <el-input placeholder="请输入剩余数量，该漂流瓶当前剩余的数量" style="width:400px;" max-l v-model="subData.nowCount"></el-input>
        </el-col>
      </el-row>

      <el-row class="bt" style="padding:15px 0; padding-left: 100px;">
        <el-button type="primary" @click="submitEvent">确定</el-button>
        <el-button plain type="primary" @click="backEvent">返回</el-button>
      </el-row>
    </el-card>
  </div>
</template>

  
<script>

export default {
  data() {
    return {
      id: this.$route.query.id?this.$route.query.id:0,
      subData:{
        typeId : '',
        title : '',
        remark : '',
        imgPath : '',
        voicePath : '',
        num : '',
        rate : '',
        maxCount : '',
        nowCount : '',
      },
      uploadUrl: '',
      typeList:[],
      typeValueId:'',
      typeShowName: ''
    }
  },
  mounted:function(){
    this.uploadUrl = this.API_URL + '/file/upload'
    this.getTypePage()
  },
  watch:{
    typeValueId:function(newVal, oldVal){
      for(var i = 0; i < this.typeList.length; i++){
        var obj = this.typeList[i];
        if(obj.id == newVal){
          this.typeShowName = obj.name
        }
      }
    }
  },
  methods: {
    backEvent(){
        this.$router.go(-1)
    },
    handleAvatarSuccess(res, file) {
      this.subData.imgPath = res.data;
    },
    beforeAvatarUpload(file) {
      const isJPG = true; //file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    getTypePage(){
      var ths = this
      var queryBO = {
        name: '',
        page: 1,
        pageSize: 1000,
        sortField: ''
      }
      ths.$post('/DriftBottleTypes/queryPage',queryBO)
      .then(function (res) { 
          if(res.success){
            ths.typeList = res.data.rows
            if(ths.id>0){
              ths.getData()
            }
          }
      })
      .catch(function (err) {
        console.log(err)
      })    
    },
    getData(){
      var ths = this
      ths.$get('/DriftBottles/queryById?id='+ths.id)
      .then(function (res) { 
          if(res.success){
            ths.subData = res.data
            ths.typeValueId = res.data.typeId
          }
      })
      .catch(function (err) {
        console.log(err)
      })    
    },
    submitEvent() {
      const ths = this;
      if(this.subData.typeName == '物品'){
        this.subData.num = 0;
      }
      this.subData.typeId = this.typeValueId
      ths.$post('/DriftBottles/edit?', ths.subData)
        .then(function (res) { 
            alert(res.msg)
            if(res.success){
              ths.$router.push("/Admin/DriftBottlesList")
            }
        })
        .catch(function (err) {
          console.log(err)
        })      
      },
   }
}

</script>

<style>
.form-row{
  padding:15px 0; 
}
</style>